<template>
	<div class="url-placement-data">
		<ToolNameInputField class="" v-model="name" />
		<div>
			<h3 class="reg extra-details">You will be able to run this feature from Slack by using the slash command "/ply [Feature Name]"</h3>
		</div>
	</div>
</template>

<script>
import ToolNameInputField from './common/ToolNameInputField.vue';
import ToolPlacementDataMixin from './ToolPlacementDataMixin';

export default {
	name: 'ToolSlackPlacementData',
	mixins: [ToolPlacementDataMixin],
	components: { ToolNameInputField },
	methods: {
		getToolPlacementData() {
			return { name: this.name };
		},
	},
	data() {
		return { name: '' };
	},
	// used in ToolPlacementDataMixin
	requiredFields: ['name'],
};
</script>

<style lang="scss" scoped>
.extra-details {
	color: #474647;
}
</style>
